module.exports = __webpack_public_path__ + "img/HK.e5c8bbb8.svg";